export default __webpack_public_path__ + "static/media/new-ai-logo-darkblue.a0298808.svg";